import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { ValidationError } from "yup"
import { isEmpty } from "@ui-seeker/utils"

// Same hook as @ui-seeker/app 0.44.11 (it also answers isValid)
export default function useValidatorSeeker(dataSend, schema) {
    const errors = useSignal({})

    useEffect(() => {
        try {
            schema.validateSync(dataSend, { abortEarly: false })
            errors.value = {}
        } catch (err) {
            if (err instanceof ValidationError) {
                errors.value = err.inner.reduce((acc, error) => ({
                    ...acc,
                    [error.path]: error.message,
                }), {})
            } else {
                throw err
            }
        }
    }, [JSON.stringify(dataSend), JSON.stringify(schema.describe())])

    return {
        isValid: isEmpty(errors.value),
        errors: errors.value,
    }
}
